//Product description metafields
document.addEventListener('DOMContentLoaded', function () {
    const viewMoreButton = document.querySelector('.metafield-description--view-more');
    const hiddenMetafields = document.querySelector('.metafields-description--hidden');
  
    hiddenMetafields.style.maxHeight = '0'; 
    hiddenMetafields.style.overflow = 'hidden'; 
  
    viewMoreButton.addEventListener('click', function () {
        if (hiddenMetafields.style.maxHeight === '0px') {
            hiddenMetafields.style.maxHeight = hiddenMetafields.scrollHeight + 'px';
            viewMoreButton.textContent = 'View Less -';
        } else {
            hiddenMetafields.style.maxHeight = '0';
            viewMoreButton.textContent = 'View More +';
        }
    });
  
  });
  
  document.addEventListener('DOMContentLoaded', function () {
    const viewMore = document.querySelector('.product-care--view-more');
    const hidden = document.querySelector('.product-care--hidden');
  
    hidden.style.maxHeight = '0';
    hidden.style.overflow = 'hidden';
  
    viewMore.addEventListener('click', function () {
      if (hidden.style.maxHeight === '0px') {
        hidden.style.maxHeight = hidden.scrollHeight + 'px';
        viewMore.textContent = 'View Less -';
      } else {
        hidden.style.maxHeight = '0';
          viewMore.textContent = 'View More +';
      }
  });
  
  });

  //Back top top button
document.addEventListener('DOMContentLoaded', function () {
    const backToTopButton = document.querySelector('.custom--back-to-top');
  
    const toggleButton = () => {
      if (window.scrollY > 400) {
        backToTopButton.classList.add('visible');
      } else {
        backToTopButton.classList.remove('visible');
      }
    };
  
    backToTopButton.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
    window.addEventListener('scroll', toggleButton);
  
    toggleButton();
  });